var core = module.exports = { version: '2.6.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_core.js
// module id = ../node_modules/core-js/modules/_core.js
// module chunks = 1